import axiosLDAP from '../../axiosLDAP.js'

export default axiosLDAP
